import { createElement } from 'react';
import { Grid, Input, Icon, NumberPicker, DatePicker, Switch } from '@alifd/next';
import { mapping } from './jsonSchema';
import DictSelect from './dictSelect';
import _, { isEmpty } from 'lodash';
const { Row, Col } = Grid;
const SchemaItem = (props) => {
    const { key, name, prefix, data, showEdit, model, open, index } = props;
    const value = data.properties[name] || {};
    const prefixArray = [].concat(prefix, name);
    const tagPaddingLeftStyle = () => {
        const { length } = props.prefix.filter((name) => name != 'properties');
        return {
            paddingLeft: `${20 * (length + 1)}px`,
        };
    };
    const showIcon = () => {
        const prefixArray = [].concat(prefix, name);
        const prefixArrayStr = [].concat(prefixArray, 'properties').join('.');
        return _.get(open, prefixArrayStr);
    };
    const getPrefix = () => {
        return [].concat(props.prefix, props.name);
    };
    const handleAddArrayField = (value) => {
        const prefix = getPrefix();
        const key = [].concat(prefix, 'fields');
        props.model.addArrayItems(key, value);
    };
    const handleClickIcon = () => {
        const prefix = getPrefix();
        const keyArr = [].concat(prefix, 'properties');
        props.model.setOpenValueAction(keyArr);
    };
    const changeValueDict = (value) => {
        const prefix = getPrefix();
        const key = [].concat(prefix, 'dictType');
        props.model.changeValueAction(key, value);
        const saveKey = [].concat(prefix);
        props.model.setSaveValue(saveKey, value, index);
    };
    const handleChangeValue = (value) => {
        const prefix = getPrefix();
        const key = [].concat(prefix);
        props.model.setSaveValue(key, value, index);
        const descriptionKey = [].concat(prefix, 'desc');
        props.model.changeValueAction(descriptionKey, value);
    };
    const renderColDesc = () => {
        const { type, dict } = value;
        const isDict = !isEmpty(dict);
        if (isDict) {
            return (createElement(DictSelect, { onChange: (value) => changeValueDict(value), initialValues: value.dict, placeholder: '请选择', value: value.dictType }));
        }
        if (type == 'number' || type == 'money' || type == 'integer' || type == 'rate') {
            return (createElement(NumberPicker, { style: { width: '100%' }, value: value.desc, onChange: (value) => handleChangeValue(value) }));
        }
        else if (type == 'boolean') {
            return createElement(Switch, { checked: value.desc, onChange: (value) => handleChangeValue(value) });
        }
        else if (type == 'date') {
            return (createElement(DatePicker, { value: value.desc, onChange: (value) => handleChangeValue(value), format: 'YYYY/MM/DD', style: { width: '100%' } }));
        }
        else {
            return (createElement(Input, { value: value.desc, onChange: (value) => handleChangeValue(value), placeholder: value.type == 'object' || value.type == 'array' ? '' : '请输入', disabled: value.type == 'object' || value.type == 'array' }));
        }
    };
    const show = () => {
        const prefixStr = [].concat(prefix).join('.');
        return _.get(open, prefixStr);
    };
    return show() ?
        (createElement("div", null,
            createElement(Row, { justify: "center" },
                createElement(Col, { span: 12, className: "col-item name-item col-item-name", style: tagPaddingLeftStyle() },
                    createElement(Row, { justify: "center" },
                        createElement(Col, { span: 2, className: "down-style-col" }, value.type === 'object' ? (createElement("span", { onClick: handleClickIcon }, showIcon() ? createElement(Icon, { type: "arrow-down", size: 'small' }) : createElement(Icon, { type: "arrow-up", size: 'small' }))) : null),
                        createElement(Col, { span: 22 },
                            createElement(Input, { value: isEmpty(value.description) ? `${name}` : `${name}(${value.description})` })))),
                createElement(Col, { span: 10, className: "col-item col-item-desc" }, renderColDesc()),
                createElement(Col, { span: 2, className: "col-item col-item-setting" }, value.type === 'array' && (createElement("span", { onClick: () => handleAddArrayField(value.items) },
                    createElement(Icon, { type: "add", size: 'small' }))))),
            createElement("div", { className: "option-formStyle" }, mapping(prefixArray, value, showEdit, model, open, '')))) : null;
};
export default SchemaItem;
